import { notification } from "antd";
import moment from "moment";
import CryptoJS from "crypto-js";

let key, iv;

if (process.env.REACT_APP_ENV == "production") {
    key = CryptoJS.enc.Utf8.parse("%Qw3EjC&MpIK!pIHdK53c%3Wk7uY@RT#");
    iv = CryptoJS.enc.Utf8.parse("W#gTJ5)(WqDL@rY$");
} else {
    key = CryptoJS.enc.Utf8.parse("FnzmMdyU5vqNbJBQsYepw6tjHOiPhTRK");
    iv = CryptoJS.enc.Utf8.parse("LdY2PxrR9jiCBV7Q");
}

export function encrypt(string) {
    if (string) {
        const encrypted_str = CryptoJS.AES.encrypt(string, key, {
            iv,
        }).toString();
        return encrypted_str;
    }
    return string;
}

export function decrypt(string) {
    if (string) {
        const decrypted_str = CryptoJS.AES.decrypt(string, key, { iv });
        const final_decrypted_str = decrypted_str.toString(CryptoJS.enc.Utf8);
        return final_decrypted_str;
    }
    return string;
}

const Roles = [
    { key: "a", name: "Super Admin" },
    { key: "b", name: "Admin" },
    { key: "s", name: "Support" },
    { key: "c", name: "Customer" },
    { key: "o", name: "Operations" },
    { key: "sl", name: "Sales" },
    { key: "cs", name: "Customer Success" },
    { key: "fda", name: "Front Desk Agent" },
    { key: "fdt", name: "Front Desk Team Lead" },
    { key: "m", name: "Management" },
    { key: "thp", name: "Third Party" },
    { key: "exv", name: "External Vendor" },
];

export const vendorTypes = [
    { key: "1", name: "PMS" },
    { key: "2", name: "PBX" },
    { key: "3", name: "Internet/Security" },
    { key: "4", name: "Credit Card" },
    { key: "5", name: "Key" },
    { key: "6", name: "Other" },
];

export const reviewTypes = [
    { key: "3", name: "Excellent" },
    { key: "2", name: "Good" },
    { key: "1", name: "Poor" },
];

export function getUserRole(roleId = localStorage.getItem("userRoleId")) {
    const matched = Roles.find((e) => roleId == e.key);
    if (matched) {
        return matched.name;
    }
    return null;
}

export { Roles };

export const weekDays = [
    { key: 0, title: "Sunday" },
    { key: 1, title: "Monday" },
    { key: 2, title: "TuesDay" },
    { key: 3, title: "Wednesday" },
    { key: 4, title: "Thursday" },
    { key: 5, title: "Friday" },
    { key: 6, title: "Saturday" },
];

export const months = [
    { key: "01", title: "January" },
    { key: "02", title: "February" },
    { key: "03", title: "March" },
    { key: "04", title: "April" },
    { key: "05", title: "May" },
    { key: "06", title: "June" },
    { key: "07", title: "July" },
    { key: "08", title: "August" },
    { key: "09", title: "September" },
    { key: "10", title: "October" },
    { key: "11", title: "November" },
    { key: "12", title: "December" },
];

export const timeZoneOptions = ["PST", "EST", "CST", "MST"];

export const hotelTypeOptions = [
    { key: "all", title: "All" },
    { key: "kiosk", title: "Kiosk Hotels" },
    { key: "operation", title: "Operational Hotels" },
];

export function downloadCSV(res, filename) {
    if (res) {
        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${filename}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    } else {
        notification["error"]({
            message: "Not able to downlaod.Please try after some time.",
        });
    }
}

export function formatDate(date, format) {
    if (!format) return moment(date).format("YYYY/MM/DD");
    return moment(date).startOf("minute").format(format);
}

export const getBase64 = (fileObj, callback) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(fileObj);
};

export const issuePriorities = [
    "Critical",
    "Low",
    "Showstopper",
    "Unprioritized",
    "High",
    "Medium",
];

export const shiftTypes = [
    { title: "Morning", key: "am" },
    { title: "Noon", key: "pm" },
    { title: "Night", key: "night" },
];

export function disableFutureDates(current) {
    return current && current > moment().endOf("day");
}

export const initialDateRange = [
    moment().subtract(7, "days").startOf("day"),
    moment(),
];
